// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiCreateGroupDescription } from '../models/ApiCreateGroupDescription';
import { HttpFile } from '../http/http';

export class ApiCreateGroup {
    'name': string;
    'group': ApiCreateGroupDescription;
    'is_private'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "group",
            "baseName": "group",
            "type": "ApiCreateGroupDescription",
            "format": ""
        },
        {
            "name": "is_private",
            "baseName": "is_private",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCreateGroup.attributeTypeMap;
    }

    public constructor() {
    }
}

